import { motion } from "framer-motion";
import { Check, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { scrollToId } from "@/lib/scroll";
import { Editable } from "@/components/builder/Editable";
import { useContent } from "@/context/ContentContext";

const BULLETS = [
  { key: "b1", text: "Tutte le comunicazioni (email, PEC, WhatsApp) in un unico posto" },
  { key: "b2", text: "Pratiche aperte in automatico, con priorita e fornitori suggeriti" },
  { key: "b3", text: "Meno tempo su smistamento, risposte e ricerca documenti" },
  { key: "b4", text: "Segnalazioni dei condomini gestite senza perdere nulla" },
  { key: "b5", text: "Onboarding semplice: importi anagrafiche con un trascinamento" },
];

export const Benefits = () => {
  const { ctaClick } = useContent();
  return (
    <section id="perche-sedio" data-testid="benefits" className="section-lavender">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 py-16 sm:px-6 lg:grid-cols-2 lg:px-8 lg:py-24">
        <div>
          <Editable as="p" path="ben.eyebrow" className="mb-3 block text-xs font-bold uppercase tracking-[0.16em] text-primary">Perche Sedio</Editable>
          <Editable as="h2" path="ben.title" className="block font-display text-4xl font-extrabold text-foreground sm:text-5xl">Piu tempo per amministrare, meno lavoro ripetitivo.</Editable>
          <Editable as="p" path="ben.desc" className="mt-4 block text-base leading-7 text-muted-foreground">Sedio non sostituisce l'amministratore: gli fa da spalla operativa. L'AI prepara, propone e organizza; tu approvi e decidi.</Editable>
          <ul className="mt-8 space-y-4">
            {BULLETS.map((b, i) => (
              <motion.li key={b.key} initial={{ opacity: 0, x: -10 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.35, delay: i * 0.06 }} className="flex items-start gap-3">
                <span className="mt-0.5 inline-flex h-6 w-6 flex-none items-center justify-center rounded-full bg-primary/10 text-primary"><Check className="h-4 w-4" strokeWidth={2.4} /></span>
                <span className="text-sm leading-6 text-foreground md:text-base"><Editable path={`ben.${b.key}`}>{b.text}</Editable></span>
              </motion.li>
            ))}
          </ul>
          <div className="mt-8"><Button data-testid="benefits-cta-button" onClick={ctaClick("benefits.cta.link", "https://app.sedio.it")} className="btn-cta h-11 px-7"><Editable path="ben.cta">Provalo gratis</Editable></Button></div>
        </div>
        <div className="card-soft p-8">
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-primary text-primary-foreground"><ShieldCheck className="h-6 w-6" /></span>
          <Editable as="h3" path="ben.boxTitle" className="mt-5 block font-display text-2xl font-extrabold text-foreground">Tu decidi, sempre.</Editable>
          <Editable as="p" path="ben.boxDesc" className="mt-3 block text-sm leading-6 text-muted-foreground">L'intelligenza artificiale lavora per te ma non agisce mai da sola sulle decisioni importanti: ogni bozza, assegnazione o comunicazione passa dalla tua approvazione prima di partire. Il controllo resta nelle tue mani.</Editable>
          <div className="mt-6 grid grid-cols-2 gap-4">
            <div className="rounded-2xl bg-[hsl(var(--muted))] p-4"><p className="font-display text-2xl font-extrabold text-primary">1</p><p className="text-xs text-muted-foreground">agente per comunicazione e segnalazioni</p></div>
            <div className="rounded-2xl bg-[hsl(var(--muted))] p-4"><p className="font-display text-2xl font-extrabold text-primary">100%</p><p className="text-xs text-muted-foreground">controllo umano sulle decisioni</p></div>
          </div>
        </div>
      </div>
    </section>
  );
};
